import ReactGA from 'react-ga';
ReactGA.initialize(process.env.REACT_APP_GA, { debug: false });

//appName: 'ESL web'

export default ReactGA;